import { Colors } from "../types/colors";
import { getClassName } from "@pairtreefamily/utils";

type CircleProps = {
  color: AccentColor;
  className?: string;
  onClick?: () => void;
};

export type AccentColor = Extract<
  Colors.Solid,
  "teal" | "darkblue" | "green" | "white"
>;

const colorMap: Record<AccentColor, string> = {
  teal: "fill-teal",
  darkblue: "fill-darkblue",
  green: "fill-green",
  white: "fill-white",
};

export function PlayButton(props: CircleProps) {
  const buttonClass = getClassName(
    "h-[84px]",
    colorMap[props.color],
    props.className,
  );

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={buttonClass}
      viewBox="0 0 20 20"
      fill="currentColor"
      onClick={props.onClick}
    >
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
        clipRule="evenodd"
      />
    </svg>
  );
}
